import "./block3.css";
function Block3(params) {
	return (
		<>
			<div className="block_3_bg">
				<h2>Pure CSS and Backgrounds Only</h2>

				<div className="block_3">
					<div className="sky"></div>
					<div className="oblako">
						<div className="oblako_1"></div>
						<div className="oblako_2"></div>
						<div className="oblako_3"></div>
						<div className="oblako_4"></div>
						<div className="oblako_5"></div>
						<div className="oblako_6"></div>
						<div className="oblako_7"></div>
						<div className="oblako_8"></div>
					</div>
					<div className="oblako2">
						<div className="oblako_2_1"></div>
						<div className="oblako_2_2"></div>
						<div className="oblako_2_3"></div>
						<div className="oblako_2_4"></div>
						<div className="oblako_2_5"></div>
						<div className="oblako_2_6"></div>
						<div className="oblako_2_7"></div>
						<div className="oblako_2_8"></div>
					</div>
					<div className="oblako3">
						<div className="oblako_3_1"></div>
						<div className="oblako_3_2"></div>
						<div className="oblako_3_3"></div>
						<div className="oblako_3_4"></div>
						<div className="oblako_3_5"></div>
						<div className="oblako_3_6"></div>
						<div className="oblako_3_7"></div>
						<div className="oblako_3_8"></div>
					</div>
					<div className="oblako4">
						<div className="oblako_5_1"></div>
						<div className="oblako_5_2"></div>
						<div className="oblako_5_3"></div>
						<div className="oblako_5_4"></div>
						<div className="oblako_5_5"></div>
					</div>
					<div className="trees3"></div>
					<div className="trees3_green3"></div>
					<div className="trees"></div>
					<div className="trees2"></div>
					<div className="trees2_green"></div>
					<div className="trees2_green2"></div>
					<div className="trava1"></div>
					<div className="trava2"></div>
					<div className="trava3"></div>
					<div className="trava4"></div>
					<div className="trava5"></div>
					<div className="trava6"></div>
					<div className="trava7"></div>
					<div className="trava8"></div>
					<div className="trava9"></div>
					<div className="trava21"></div>
					<div className="trava22"></div>
					<div className="trava23"></div>
					<div className="trava24"></div>
					<div className="trava25"></div>
					<div className="trava26"></div>
					<div className="trava27"></div>
					<div className="trava28"></div>
					<div className="trava29"></div>
					<div className="trava10"></div>
					<div className="trava11"></div>
					<div className="trava12"></div>
					<div className="trava13"></div>
					<div className="earth2"></div>
					<div className="home"></div>
					<div className="home2"></div>
					<div className="earth3"></div>
					<div className="earth4"></div>
					<div className="earth"></div>
					<div className="sun"></div>
					<div className="nlo">
						<div className="nlo_1"></div>
						<div className="sun2"></div>
						<div className="sun3"></div>
						<div className="sun4"></div>
					</div>
					<div className="laser"></div>
					<div className="sky2"></div>
					<div className="expouse">
						<div className="expouse_1"></div>
						<div className="expouse_2"></div>
						<div className="expouse_3"></div>
						<div className="expouse_4"></div>
						<div className="expouse_5"></div>
						<div className="expouse_6"></div>
						<div className="expouse_7"></div>
						<div className="expouse_8"></div>
						<div className="expouse_9"></div>
						<div className="expouse_10"></div>
					</div>
					<div className="mount">
						<div className="mount_2"></div>
						<div className="mount_1"></div>
						<div className="mount_3"></div>
						<div className="mount_4"></div>
						<div className="mount_5"></div>
						<div className="mount_6"></div>
						<div className="mount_7"></div>
						<div className="mount_8"></div>
						<div className="mount_9"></div>
						<div className="mount_10"></div>
						<div className="mount_11"></div>
						<div className="mount_12"></div>
						<div className="mount_13"></div>
						<div className="mount_14"></div>
						<div className="mount_15"></div>
						<div className="mount_16"></div>
					</div>
				</div>
			</div>
		</>
	);
}
export default Block3;
